import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "EarthAmericas"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.4998 11.9998C22.5104 7.24473 19.3309 3.07336 14.7431 1.82326C10.1553 0.573166 5.29923 2.55497 2.89611 6.65811C0.492999 10.7612 1.14003 15.9661 4.47461 19.356C7.8092 22.7459 13.0027 23.4784 17.1448 21.143L17.2326 21.1625L17.2506 21.0793C20.495 19.2061 22.4954 15.7461 22.4998 11.9998ZM2.99976 11.9998C3.00267 11.2403 3.10222 10.4842 3.29601 9.7498H6.47826L10.2223 12.8698L8.78976 14.7793C8.34497 15.3774 8.40427 16.2107 8.92926 16.7398L10.4998 18.3103V20.864C6.17476 20.1299 3.00765 16.3867 2.99976 11.9998ZM9.98989 15.6793L12.2774 12.6298L7.02139 8.2498H3.82939C4.93717 5.81976 7.06998 4.00958 9.64778 3.31156C12.2256 2.61353 14.9803 3.10023 17.1629 4.6393L16.7091 5.9998H12.4394L10.1571 8.28205L17.1726 14.5168L15.9359 20.0811C14.7114 20.6842 13.3649 20.9985 11.9999 20.9998V17.6893L9.98989 15.6793ZM17.726 18.9373L18.6358 14.8423C18.7535 14.3115 18.5747 13.7585 18.1685 13.397L12.3425 8.21754L13.0603 7.49979H16.709C17.3551 7.50041 17.9288 7.0869 18.1325 6.47379L18.3973 5.67879C20.1753 7.47319 21.1157 9.93329 20.988 12.4562C20.8602 14.9791 19.6762 17.3316 17.726 18.9373Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/EarthAmericas.vue"]]);
